import { render, staticRenderFns } from "./MisMaterias.vue?vue&type=template&id=5618bc5e&scoped=true"
import script from "./MisMaterias.vue?vue&type=script&lang=js"
export * from "./MisMaterias.vue?vue&type=script&lang=js"
import style0 from "./MisMaterias.vue?vue&type=style&index=0&id=5618bc5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5618bc5e",
  null
  
)

export default component.exports